import { styled } from "styled-components";
import { BASIC_BROWN } from "../../../constants/colors";

type Props = {
  index: number;
  title: string;
};

export const AppLinkageItem: React.FC<Props> = ({ index, title }) => {
  return (
    <Container>
      <Header>
        <img
          src={require(`../../../assets/app_coupon/num${index}.png`)}
          alt={`App Linkage Step ${index}`}
        />
        <Title>{title}</Title>
      </Header>

      <AppLinkageImage
        src={require(`../../../assets/app_coupon/app-linkage-${index}.jpg`)}
        height={150}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
  padding: 20px;
  background-color: #f2c8b7;
  width: 80%;
  max-width: 600px;
  min-width: 300px;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${BASIC_BROWN};
`;

const AppLinkageImage = styled.img`
  height: 150px;
  margin-top: 8px;
`;
